import React from 'react';
import { useApp } from '../../contexts/AppContext';

const Reglages = ({
  handleSettingsSubmit,
  handleExportComptable,
  handleLogoUpload,
  activeSettingsTab,
  setActiveSettingsTab,
  exportType,
  setExportType,
}) => {
  const { settings, isComptable, isAdmin } = useApp();
  return (
    <div className="reglages">
      <div className="section-header">
        <h2>{isComptable() ? 'Export Comptable' : 'Paramètres de l\'Application'}</h2>
      </div>

      {isComptable() ? (
        <div className="settings-tab-content">
          <div className="exports-container">
            <div className="settings-section">
              <h3>📊 Export Comptable</h3>
              <p className="form-text">Exportez l'historique des commandes au format Excel pour votre comptabilité</p>
              
              <div className="export-form">
                <div className="export-options">
                  <div className="form-group">
                    <label className="radio-label">
                      <input 
                        type="radio" 
                        name="export_type" 
                        value="period" 
                        checked={exportType === 'period'}
                        onChange={(e) => setExportType(e.target.value)}
                      />
                      <span className="radio-custom"></span>
                      Export par période
                    </label>
                    <div className="period-inputs">
                      <input type="date" name="date_debut" disabled={exportType !== 'period'} required={exportType === 'period'} />
                      <span>à</span>
                      <input type="date" name="date_fin" disabled={exportType !== 'period'} required={exportType === 'period'} />
                    </div>
                  </div>
                  
                  <div className="form-group">
                    <label className="radio-label">
                      <input 
                        type="radio" 
                        name="export_type" 
                        value="annual"
                        checked={exportType === 'annual'}
                        onChange={(e) => setExportType(e.target.value)}
                      />
                      <span className="radio-custom"></span>
                      Export annuel
                    </label>
                    <div className="year-input">
                      <select name="annee" disabled={exportType !== 'annual'} required={exportType === 'annual'}>
                        {Array.from({length: 10}, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return <option key={year} value={year}>{year}</option>;
                        })}
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="radio-label">
                      <input
                        type="radio"
                        name="export_type"
                        value="stock_vendu"
                        checked={exportType === 'stock_vendu'}
                        onChange={(e) => setExportType(e.target.value)}
                      />
                      <span className="radio-custom"></span>
                      Stock vendu par produit (entre 2 dates)
                    </label>
                    <div className="period-inputs">
                      <input type="date" name="stock_date_debut" disabled={exportType !== 'stock_vendu'} required={exportType === 'stock_vendu'} />
                      <span>à</span>
                      <input type="date" name="stock_date_fin" disabled={exportType !== 'stock_vendu'} required={exportType === 'stock_vendu'} />
                    </div>
                  </div>
                </div>
                
                <div className="form-actions">
                  <button type="button" className="btn btn-primary" onClick={handleExportComptable}>
                    📊 Télécharger l'export XLS
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="settings-tabs">
            <button 
              className={`settings-tab ${activeSettingsTab === 'general' ? 'active' : ''}`}
              onClick={() => setActiveSettingsTab('general')}
            >
              🏢 Paramètres généraux
            </button>
            {isAdmin() && (
              <button 
                className={`settings-tab ${activeSettingsTab === 'exports' ? 'active' : ''}`}
                onClick={() => setActiveSettingsTab('exports')}
              >
                📊 Exports
              </button>
            )}
          </div>

          <div className="settings-tab-content">
            {activeSettingsTab === 'general' && settings && (
              <div className="settings-container">
                <form onSubmit={handleSettingsSubmit} className="settings-form">
                  <div className="settings-section">
                    <h3>🏢 Informations de l'Entreprise</h3>
                    <div className="form-group">
                      <label>Nom de l'entreprise</label>
                      <input type="text" name="nom_entreprise" defaultValue={settings.nom_entreprise} required />
                    </div>
                    <div className="form-group">
                      <label>Adresse</label>
                      <textarea name="adresse" defaultValue={settings.adresse} required />
                    </div>
                    <div className="form-group">
                      <label>SIRET</label>
                      <input type="text" name="siret" defaultValue={settings.siret || ''} placeholder="Numéro SIRET de l'entreprise" />
                    </div>
                    <div className="form-group">
                      <label>N° TVA intracommunautaire</label>
                      <input type="text" name="numero_tva_intra" defaultValue={settings.numero_tva_intra || ''} placeholder="FR12345678901 (optionnel, pour export UE)" />
                    </div>
                    <div className="form-group">
                      <label>Numéro Ecocert</label>
                      <input type="text" name="numero_ecocert" defaultValue={settings.numero_ecocert || ''} placeholder="Numéro de certification Ecocert (pour produits bio)" />
                    </div>
                    <div className="form-group">
                      <label>IBAN</label>
                      <textarea name="numero_iban" defaultValue={settings.numero_iban || ''} placeholder="IBAN de l'entreprise (apparaîtra en bas des factures)" rows="3" />
                      <small className="form-text">L'IBAN apparaîtra en bas des factures pour les paiements clients</small>
                    </div>
                    <div className="form-group">
                      <label>Capital Social</label>
                      <input type="text" name="capital_social" defaultValue={settings.capital_social || ''} placeholder="Ex: 10 000 EUR" />
                      <small className="form-text">Le capital social apparaîtra dans les informations de l'entreprise sur les factures</small>
                    </div>
                    <div className="form-group">
                      <label>Devise</label>
                      <select name="devise" defaultValue={settings.devise || 'EUR'} data-testid="devise-select">
                        <option value="EUR">Euro (€) — symbole à droite (123,45 €)</option>
                        <option value="CAD">Dollar canadien ($) — symbole à gauche ($123.45)</option>
                      </select>
                      <small className="form-text">La devise sélectionnée s'appliquera sur tout le site : affichage, factures et emails</small>
                    </div>
                    <div className="form-group">
                      <label className="checkbox-label">
                        <input type="checkbox" name="en_conversion_bio" defaultChecked={settings.en_conversion_bio || false} />
                        <span className="checkmark"></span>
                        🌱 En conversion à l'agriculture biologique
                      </label>
                      <p className="form-text">Cette mention apparaîtra sur les factures et bons de livraison. Décochez une fois la conversion terminée.</p>
                    </div>
                    <div className="form-group">
                      <label>Seuil d'alerte de stock par défaut</label>
                      <input type="number" name="seuil_stock_defaut" step="0.01" min="0" defaultValue={settings.seuil_stock_defaut || 10} required />
                      <small className="form-text">Cette valeur sera utilisée pour les produits sans seuil personnalisé</small>
                    </div>
                    <div className="form-group toggle-group">
                      <div className="toggle-container">
                        <div className="toggle-header">
                          <label htmlFor="gestion_stock_active" className="toggle-title">Gestion du stock pour les commandes</label>
                          <div className="toggle-switch">
                            <input type="checkbox" id="gestion_stock_active" name="gestion_stock_active" defaultChecked={settings.gestion_stock_active !== false} className="toggle-checkbox" />
                            <label htmlFor="gestion_stock_active" className="toggle-label"><span className="toggle-slider"></span></label>
                          </div>
                        </div>
                        <div className="toggle-description">
                          <p className="toggle-text-active"><strong>Activé :</strong> Les commandes vérifieront et décrémenteront automatiquement le stock</p>
                          <p className="toggle-text-inactive"><strong>Désactivé :</strong> Les commandes pourront être créées sans limite de stock</p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="origine_defaut">Origine par défaut des produits</label>
                      <input type="text" id="origine_defaut" name="origine_defaut" defaultValue={settings.origine_defaut || ''} placeholder="Ex: France, Local, Produits de la région..." />
                      <small className="form-text">Cette origine sera utilisée par défaut pour tous les produits qui n'ont pas d'origine spécifique</small>
                    </div>
                  </div>

                  <div className="settings-section">
                    <h3>🎨 Apparence</h3>
                    <div className="form-group color-group">
                      <label>
                        <div className="color-preview" style={{backgroundColor: settings?.couleur_primaire || '#000000'}}></div>
                        Couleur principale
                      </label>
                      <div className="color-input-group">
                        <input type="color" name="couleur_primaire" defaultValue={settings.couleur_primaire} className="color-picker"
                          onChange={(e) => {
                            const textInput = e.target.parentElement.querySelector('.color-text');
                            const preview = e.target.parentElement.parentElement.querySelector('.color-preview');
                            textInput.value = e.target.value;
                            preview.style.backgroundColor = e.target.value;
                          }}
                        />
                        <input type="text" defaultValue={settings.couleur_primaire} className="color-text" placeholder="#000000" pattern="^#[0-9A-Fa-f]{6}$"
                          onChange={(e) => {
                            const colorPicker = e.target.previousSibling;
                            const preview = e.target.parentElement.parentElement.querySelector('.color-preview');
                            if (e.target.value.match(/^#[0-9A-Fa-f]{6}$/)) {
                              colorPicker.value = e.target.value;
                              preview.style.backgroundColor = e.target.value;
                            }
                          }}
                        />
                      </div>
                      <p className="form-text">Choisissez la couleur principale de votre interface</p>
                    </div>
                    <div className="form-group">
                      <label>Logo de l'entreprise</label>
                      <div className="logo-upload-group">
                        {settings.logo_url && (<img src={settings.logo_url} alt="Logo" className="current-logo" />)}
                        <input type="file" accept="image/*" onChange={handleLogoUpload} className="file-input" id="logo-upload" />
                        <label htmlFor="logo-upload" className="btn btn-secondary">📁 Changer le logo</label>
                      </div>
                    </div>
                  </div>

                  <div className="settings-section">
                    <h3>👥 Types de Clients</h3>
                    <div className="client-types-grid">
                      <div className="form-group">
                        <label>Type 1</label>
                        <input type="text" name="type_client_1" defaultValue={settings.types_clients[0] || ''} placeholder="Ex: GMS" />
                      </div>
                      <div className="form-group">
                        <label>Type 2</label>
                        <input type="text" name="type_client_2" defaultValue={settings.types_clients[1] || ''} placeholder="Ex: boutique" />
                      </div>
                      <div className="form-group">
                        <label>Type 3</label>
                        <input type="text" name="type_client_3" defaultValue={settings.types_clients[2] || ''} placeholder="Ex: particulier" />
                      </div>
                    </div>
                  </div>

                  <div className="settings-section">
                    <h3>📧 Emails sortants</h3>
                    <p className="form-text">Ces réglages s&apos;appliquent aux emails envoyés depuis la Comptabilité (factures, envois groupés).</p>

                    <div className="form-group">
                      <label>Nom de l&apos;expéditeur</label>
                      <input
                        type="text"
                        name="email_sender_name"
                        defaultValue={settings.email_sender_name || ''}
                        placeholder={settings.nom_entreprise || "Maraich'Pro"}
                        data-testid="email-sender-name"
                      />
                      <small className="form-text">Affiché à la place de l&apos;adresse technique côté destinataire (ex: « Ferme de l&apos;Arrue »).</small>
                    </div>

                    <div className="form-group">
                      <label>Modèle de sujet par défaut</label>
                      <input
                        type="text"
                        name="email_subject_template"
                        defaultValue={settings.email_subject_template || ''}
                        placeholder="Facture {numero_facture} - {nom_entreprise}"
                        data-testid="email-subject-template"
                      />
                      <small className="form-text">Utilisé si l&apos;utilisateur n&apos;entre pas de sujet. Placeholders ci-dessous.</small>
                    </div>

                    <div className="form-group">
                      <label>Modèle de contenu par défaut</label>
                      <textarea
                        name="email_body_template"
                        defaultValue={settings.email_body_template || ''}
                        rows={8}
                        placeholder={"Bonjour {nom_client},\n\nVeuillez trouver ci-joint vos {count} factures :\n{liste_factures}\n\nMontant total : {total_montant}\n\nCordialement,\n{nom_entreprise}"}
                        data-testid="email-body-template"
                      />
                      <small className="form-text">Utilisé si l&apos;utilisateur n&apos;entre pas de message. La signature ci-dessous est ajoutée à la fin.</small>
                    </div>

                    <div className="form-group">
                      <label>Pied de page / signature</label>
                      <textarea
                        name="email_signature"
                        defaultValue={settings.email_signature || ''}
                        rows={4}
                        placeholder={"--\nFerme de l'Arrue · 123 rue des Champs · 75000 Paris\nSIRET 123 456 789 00012 · contact@ferme.fr"}
                        data-testid="email-signature"
                      />
                      <small className="form-text">Ajouté automatiquement en fin d&apos;email, après le message principal.</small>
                    </div>

                    <details className="form-text" style={{ marginTop: '0.5rem' }}>
                      <summary style={{ cursor: 'pointer', fontWeight: 600 }}>📌 Placeholders disponibles</summary>
                      <ul style={{ marginTop: '0.5rem', paddingLeft: '1.25rem', lineHeight: 1.7 }}>
                        <li><code>&#123;nom_entreprise&#125;</code> — votre nom d&apos;entreprise</li>
                        <li><code>&#123;nom_client&#125;</code> — nom de l&apos;entreprise cliente</li>
                        <li><code>&#123;numero_facture&#125;</code> — numéro de facture (uniquement si 1 seule facture)</li>
                        <li><code>&#123;count&#125;</code> — nombre de factures envoyées au client</li>
                        <li><code>&#123;montant_ttc&#125;</code> — montant TTC (facture unique) ou total (multi-factures)</li>
                        <li><code>&#123;total_montant&#125;</code> — somme TTC de toutes les factures du client</li>
                        <li><code>&#123;liste_factures&#125;</code> — liste à puces des factures avec montants</li>
                      </ul>
                    </details>
                  </div>

                  <div className="form-actions">
                    <button type="submit" className="btn btn-primary">Sauvegarder les paramètres</button>
                  </div>
                </form>
              </div>
            )}

            {activeSettingsTab === 'exports' && isAdmin() && (
              <div className="exports-container">
                <div className="settings-section">
                  <h3>📊 Export Comptable</h3>
                  <p className="form-text">Exportez l'historique des commandes au format Excel pour votre comptabilité</p>
                  <div className="export-form">
                    <div className="export-options">
                      <div className="form-group">
                        <label className="radio-label">
                          <input type="radio" name="export_type" value="period" checked={exportType === 'period'} onChange={(e) => setExportType(e.target.value)} />
                          <span className="radio-custom"></span>
                          Export par période
                        </label>
                        <div className="period-inputs">
                          <input type="date" name="date_debut" disabled={exportType !== 'period'} required={exportType === 'period'} />
                          <span>à</span>
                          <input type="date" name="date_fin" disabled={exportType !== 'period'} required={exportType === 'period'} />
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="radio-label">
                          <input type="radio" name="export_type" value="annual" checked={exportType === 'annual'} onChange={(e) => setExportType(e.target.value)} />
                          <span className="radio-custom"></span>
                          Export annuel
                        </label>
                        <div className="year-input">
                          <select name="annee" disabled={exportType !== 'annual'} required={exportType === 'annual'}>
                            {Array.from({length: 10}, (_, i) => {
                              const year = new Date().getFullYear() - i;
                              return <option key={year} value={year}>{year}</option>;
                            })}
                          </select>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="radio-label">
                          <input type="radio" name="export_type" value="stock_vendu" checked={exportType === 'stock_vendu'} onChange={(e) => setExportType(e.target.value)} />
                          <span className="radio-custom"></span>
                          Stock vendu par produit (entre 2 dates)
                        </label>
                        <div className="period-inputs">
                          <input type="date" name="stock_date_debut" disabled={exportType !== 'stock_vendu'} required={exportType === 'stock_vendu'} />
                          <span>à</span>
                          <input type="date" name="stock_date_fin" disabled={exportType !== 'stock_vendu'} required={exportType === 'stock_vendu'} />
                        </div>
                      </div>
                    </div>
                    <div className="form-actions">
                      <button type="button" className="btn btn-primary" onClick={handleExportComptable}>
                        📊 Télécharger l'export XLS
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Reglages;
